var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fts-radio-group",class:[
    {'radio-group--dir-h': _vm.horizontal},
    {'comfort-design': _vm.comfortDesign}
  ]},[_c('div',{staticClass:"radio-group-container"},[_vm._t("default")],2)])}
var staticRenderFns = []
export { render, staticRenderFns }